import React from "react";
import Loading from "./loading";
import ErrorPage from "./errorpage";
import ITeamInfo from "../interfaces/ITeamInfo";
import { loadState } from "../utils/enums";
import FirebaseService from "../services/firebaseService";
import IMatchInfo from "../interfaces/IMatchInfo";
import firebase from "firebase/compat";

interface Props {}

interface State {
    teams: Array<ITeamInfo>,
    matches: Array<IMatchInfo>,
    loadState: loadState
}

const knockoutRound = 4;

const roundTimes: { [id: number] : string} = {
    1: '15th February - 22nd February',
    2: '23rd February - 1st March',
    3: '2nd March - 8th March',
    4: '9th March - 15th March',
    5: '15th March - 20th March',
    6: '20th March - 22nd March'
}

export default class Invitational extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            teams: [],
            matches: [],
            loadState: loadState.loading
        }
    }

    render() {
        switch (this.state.loadState) {
            case loadState.loading:
                return <Loading />
            case loadState.found:
                return this.loaded();
            default:
                return <ErrorPage />
        }
    }

    loaded() {
        const teamRows = this.state.teams
        .sort((a, b) => b.score - a.score)
        .map(team => 
            <tr key={team.id}>
                <td title="Name">{team.name}</td>
                <td title="Score">{team.score}</td>
            </tr>
        );

        const groupStageRows = this.state.matches.filter(m => m.round <= knockoutRound)
        .map(match => {
            const time = this.getTime(match.time, match.round);

            const stream = match.stream === undefined ?
                'TBD' :
                <a href={`https://twitch.tv/${match.stream}`}>{match.stream}</a>

            const homeTeamName = this.state.teams.find(t => t.id === match.homeTeam)?.name ?? 'ERROR';
            const awayTeamName = this.state.teams.find(t => t.id === match.awayTeam)?.name ?? 'ERROR';
            return <tr key={match.id}>
                <td title="Team">{homeTeamName}</td>
                <td title="Score">{match.homeResult ?? '-'}</td>
                <td title="Team">{awayTeamName}</td>
                <td title="Score">{match.awayResult ?? '-'}</td>
                <td title="Time">{time}</td>
                <td title="Stream">{stream}</td>
            </tr>
        });

        const knockoutRows = this.state.matches.filter(m => m.round > knockoutRound)
        .map(match => {
            const time = this.getTime(match.time, match.round);

            const stream = match.stream === undefined ?
                'TBD' :
                <a href={`https://twitch.tv/${match.stream}`}>{match.stream}</a>
            
            const homeTeamName = this.state.teams.find(t => t.id === match.homeTeam)?.name ?? match.homeTeam;
            const awayTeamName = this.state.teams.find(t => t.id === match.awayTeam)?.name ?? match.awayTeam;
            
            const rows = [];
            if (match.matchName !== undefined) {
                rows.push(<tr><th colSpan={6}>{match.matchName}</th></tr>);
            }
            rows.push(<tr key={match.id}>
                    <td title="Team 1" className={match.homeResult > match.awayResult ? "winner" : ""}>{homeTeamName}</td>
                    <td title="Score">{match.homeResult ?? '-'}</td>
                    <td title="Team 2" className={match.awayResult > match.homeResult ? "winner" : ""}>{awayTeamName}</td>
                    <td title="Score">{match.awayResult ?? '-'}</td>
                    <td title="Time">{time}</td>
                    <td title="Stream">{stream}</td>
                </tr>)
            return rows;
        }).flat();

        return <div>
            <h1>GFG Invitational 2026</h1>
            <p>
                Give the love of your life what they really want this Valentine's day - the GFG Invitational Tournament 2026!
            </p>
            <p>
                The tournament kicks off on the 14th of February on <a href="https://twitch.tv/scottehboy7">Scotteh's Twitch</a>, with games running all the way up to the start of ESL One Birmingham.
            </p>
            <h2>Teams</h2>
            <table>
                <thead>
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Group stage score</th>
                    </tr>
                </thead>
                <tbody>
                    {teamRows}
                </tbody>
            </table>
            {(knockoutRows.length > 0 || groupStageRows.length > 0) ? <h2>Schedule</h2> : ""}
            {knockoutRows.length > 0 ? <>
                <h3>Knockout stage</h3>
                <table className={"max-width"}>
                    <thead>
                        <tr>
                            <th scope="col">Team 1</th>
                            <th scope="col">Score</th>
                            <th scope="col">Team 2</th>
                            <th scope="col">Score</th>
                            <th scope="col">Time</th>
                            <th scope="col">Stream</th>
                        </tr>
                    </thead>
                    <tbody>
                        {knockoutRows}
                    </tbody>
                </table>
            </> : ""}
            
            {groupStageRows.length > 0 ? <>
                <h3>Group stage</h3>
                <table className={"max-width"}>
                    <thead>
                        <tr>
                            <th scope="col">Team</th>
                            <th scope="col">Score</th>
                            <th scope="col">Team</th>
                            <th scope="col">Score</th>
                            <th scope="col">Time</th>
                            <th scope="col">Stream</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groupStageRows}
                    </tbody>
                </table>
            </> : ""}
            
        </div>
    }

    async componentDidMount() {
        const firebaseService = new FirebaseService();
        const teams = await firebaseService.getInvitationalTeams(2026);
        const matches = await firebaseService.getInvitationalMatches(2026);
        for (const team of teams) {
            let score = matches.filter(m => m.homeTeam === team.id && m.round <= knockoutRound).reduce((prev, curr) => prev + (curr.homeResult ?? 0), 0);
            score += matches.filter(m => m.awayTeam === team.id && m.round <= knockoutRound).reduce((prev, curr) => prev + (curr.awayResult ?? 0), 0);
            team.score = score;
        }
        this.setState({
            teams: teams,
            matches: matches,
            loadState: loadState.found
        });
    }

    private getTime(time: string | firebase.firestore.Timestamp, round: number): string {
        if (typeof time === "string") {
            return time;
        } else {
            return time === undefined ?
                roundTimes[round] :
                time.toDate().toLocaleString(navigator.language, {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric"
                });
        }
    }
}